import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Swal from "sweetalert2";
import { SVGs } from "../../assets/svg/SVGs";
import ProfileType from "./E-ProfileType";
import {
  HOST_URL,
  SK_VALUE,
  getCookie,
  reqOptions,
} from "../../assets/js/helpFunction";
import { getEstateID } from "../partials/utils";

const CreateAnnoun = ({ onClose }) => {
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState({
    description: "",
    title: "",
    estate_id: getEstateID(),
  });

  const createEmergency = (data) => {
    const objectToArray = Object.entries(data);
    const formData = new FormData();

    objectToArray.forEach((entries) => {
      formData.append(entries[0], entries[1]);
    });

    const requestOptions = {
      method: "post",
      headers: {
        "EstateIQ-Sk-Header": SK_VALUE(),
        "X-CSRFToken": getCookie("CSRF-TOKEN"),
        Origin: window.location.origin,
        Authorization: "Bearer " + getCookie("access"),
      },
      body: formData,
    };

    const api = `${HOST_URL()}estate_adverts/announcement/`;
    setLoading(true);
    fetch(api, requestOptions)
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const errResponse = await res.json();
          Swal.fire({
            title: JSON.stringify(errResponse),
            icon: "error",
            showConfirmButton: true,
            showCloseButton: true,
          });
          throw new Error();
        }
      })
      .then((dataReturned) => {
        onClose();
        Swal.fire({
          title: `<div>You created an announcement <h4> ${data.title}</h4> </div>`,
          icon: "success",
          showConfirmButton: true,
          showCloseButton: true,
        });
      })
      .catch((err) => {})
      .finally(() => setLoading(false));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    createEmergency(inputValue);
  };

  return (
    <form
      onSubmit={handleSubmit}
      // method="post"
      // action="/profile"
      className="new_estates_form fade-in-bck"
    >
      <div className="form-group">
        {/* <label htmlFor="title">Email address</label> */}

        <div className="create_est ">
          <div className="form_txt">
            <div className="capture_close">
              <h4>Create Announcement</h4>
            </div>
          </div>

          <input
            value={inputValue.title}
            onChange={(e) =>
              setInputValue((initValues) => ({
                ...initValues,
                title: e.target.value,
              }))
            }
            type="text"
            id="title"
            name="title"
            placeholder="Subject"
          />

          <textarea
            value={inputValue.description}
            onChange={(e) =>
              setInputValue((initValues) => ({
                ...initValues,
                description: e.target.value,
              }))
            }
            type="text"
            id="title"
            name="title"
            placeholder="Details"
          />
        </div>
        <button disabled={loading} type="submit">
          {loading ? "Loading..." : "Send Announcement"}
        </button>
      </div>
    </form>
  );
};

const Modal = ({ open, onClose, emergencyData, onFinish }) => {
  if (!open) return null;
  return (
    <ModalWrapper onClick={onClose} className="bills_on_me">
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="modalContainer"
      >
        <CreateAnnoun emergencyData={emergencyData} onClose={onClose} />
        <img src={SVGs.close} alt="" onClick={onClose} />
      </div>
    </ModalWrapper>
  );
};
export default Modal;

let ModalWrapper = styled.div`
  .modalContainer {
    max-width: 600px;
    .new_estates_form {
      max-width: 600px;
    }
  }
  .create_est {
    h4 {
      font-size: 18px;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: left;
    }
  }
`;

let RevokeAccess = styled.div`
  .revokeOnes {
    height: 200px;
    overflow: auto;
  }
  h2 {
    font-size: 20px;

    font-weight: bold;
    margin-bottom: 0px;
  }
  .cntr {
    margin-top: 10px;
  }
`;
